export function createTouchMoveXHandler (callback: (clientX: number) => void) {
  let lastClientX: number
  let lastClientY: number

  return function (e: TouchEvent) {
    const { clientX, clientY } = e.targetTouches[0]

    const deltaX = clientX - lastClientX
    const deltaY = clientY - lastClientY

    // prevent vertical scroll while moving finger horizontally
    if (deltaX && deltaY && Math.floor(Math.abs(deltaX / deltaY)) >= 1) {
      e.preventDefault()
      callback(clientX)
    }

    lastClientX = clientX
    lastClientY = clientY
  }
}
